<template>
  <div id="preventPollution" class="page-content">
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item>外部用户</el-breadcrumb-item>
        <el-breadcrumb-item>品牌方账号</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="公司名称" :label-width="formLabelWidth">
            <el-input v-model="companyname" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注名" :label-width="formLabelWidth">
            <el-input v-model="companyMemoname" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item label="用户名" :label-width="formLabelWidth">
            <el-input v-model="username" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item label="版本" :label-width="formLabelWidth">
            <el-select v-model="version" placeholder="请选择" clearable size="small">
              <!-- <el-option label="全部" value="" ></el-option> -->
              <el-option :label="item.dictName" v-for="item in dict" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" :label-width="formLabelWidth">
            <el-select v-model="status" placeholder="请选择" clearable size="small">
              <!-- <el-option label="全部" value="" ></el-option> -->
              <el-option :key="1" label="启用" :value="1" ></el-option>
              <el-option :key="2" label="禁用" :value="2" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="theQuery(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    <div class="page">
      <el-row style="margin-bottom: 8px;">
        <el-col :span="10">
          <el-button type="primary" icon="el-icon-plus" @click="oneStep(1)" style="margin-right: 10px;" size="small">新增</el-button>
          <el-button plain style="margin-right: 10px;" @click="batchEnabled" size="small">批量启用</el-button>
          <el-button plain style="margin-right: 10px;" @click="batchOutage" size="small">批量停用</el-button>
        </el-col>
      </el-row>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{totalNum}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table ref="multipleTable" v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column label="公司名">
          <template slot-scope="scope" v-if="scope.row.companyname && scope.row.companyname != '' && scope.row.companyname != null">
            {{scope.row.companyname}}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="用户名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="companyMemoname" label="备注名" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column label="绑定手机">
          <template slot-scope="scope">
            {{ scope.row.mobile }}
            <span v-show="scope.row.mobile == ''">--</span>
            <el-button type="text" v-show="scope.row.mobile != ''" icon="el-icon-connection" @click="unbundlingAccounts(scope.row.mobile,1)">解绑手机</el-button>
          </template>
        </el-table-column>
        <el-table-column label="绑定微信">
          <template slot-scope="scope">
          {{scope.row.nickname}}
          <el-button type="text" v-show="scope.row.nickname" style="margin-left: 10px;" @click="openWechat(scope.row.openid,scope.row.userid)">解绑微信</el-button>
          <div v-show="!scope.row.nickname">--</div>
          </template>
        </el-table-column> -->
        <el-table-column label="品牌数据限额" prop="datalimit">
        </el-table-column>
        <el-table-column label="版本" prop="versionname">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status == 1" @change="stateSwitch(scope.row.status,scope.row.userid)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit-outline" @click="oneStep(2,scope.row.realname,scope.row.username,scope.row.userid,scope.row.bid,scope.row.companyname,scope.row.companyMemoname,scope.row.validtimebrm,scope.row.versionid,scope.row.members,scope.row.mobile,scope.row.datalimit)">编辑</el-button>
            <span style="color: #d9d9d9;margin-left: 10px;margin-right: 10px;">|</span>
            <el-button type="text" @click="BrandSet(scope.row.companyname,scope.row.bid,scope.row.bmcid)">品牌设置</el-button>
            <span style="color: #d9d9d9;margin-left: 10px;margin-right: 10px;">|</span>
            <el-button type="text" @click="fenKefu(scope.row.bmcid,scope.row.kefuid)">分配客服</el-button>

            <!-- <el-dropdown>
              <span class="el-dropdown-link op-btn"  @click.stop="" style="color: #409eff;cursor: pointer;">
                更多
              </span>
              <el-dropdown-menu slot="dropdown" trigger="click">
                <el-dropdown-item @click.native="BrandSet(scope.row.companyname,scope.row.bid,scope.row.bmcid)">品牌设置</el-dropdown-item>
                <el-dropdown-item @click.native="fenKefu(scope.row.bmcid,scope.row.kefuid)">分配客服</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </template>
        </el-table-column>
      </el-table>
      <div>
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
    <!-- 编辑 -->
    <div id="dialog">
      <el-dialog title="编辑" :visible.sync="theEditorShow" :close-on-click-modal='false' width="640px">
        <el-form :model="form" :rules="rules" ref="ruleForm" style="margin-top: 10px;">
          <el-form-item label="公司名称" :label-width="formLabelWidth" prop="realname">
            <el-input v-model="form.realname" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" autocomplete="off" style="width: 425px;" placeholder="请输入公司名称" size="small"></el-input>
          </el-form-item>
          <el-form-item label="用户名" :label-width="formLabelWidth" prop="username">
            <el-input v-model="form.username" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" autocomplete="off" style="width: 425px;" placeholder="请输入用户名" size="small"></el-input>
          </el-form-item>
          <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
            <el-input v-model="form.password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" autocomplete="off" style="width: 425px;" placeholder="6 - 16个字符，区分大小写" show-password size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注名" :label-width="formLabelWidth">
            <!-- <el-input type="textarea" placeholder="请输入" v-model="form.memo" style="width: 425px;" size="small"> -->
            <el-input placeholder="请输入" v-model="form.memo" style="width: 425px;" size="small">
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="form.mobile" clearable style="width: 425px;" size="small" type="number">
            </el-input>
          </el-form-item>
          <el-form-item label="版本" :label-width="formLabelWidth" prop="newAddversion">
            <el-select v-model="form.newAddversion" placeholder="请选择" clearable size="small" style="width: 425px;">
              <el-option :label="item.dictName" v-for="item in dict" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务期至" :label-width="formLabelWidth" prop="validtimebrm">
            <el-date-picker v-model="form.validtimebrm" type="date" placeholder="选择日期" style="width: 425px;" format="yyyy-MM-dd" size="small">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="客户类型" :label-width="formLabelWidth" prop="members">
            <el-radio v-model="form.members" label="0">一般客户</el-radio>
            <el-radio v-model="form.members" label="1">重点客户</el-radio>
          </el-form-item>
          <el-form-item label="品牌数据限额" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="form.datalimit" clearable style="width: 425px;" size="small" type="number">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')" size="small">确 定</el-button>
          <el-button @click="theEditorShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 编辑 -->
      <!-- 新增 -->
      <el-dialog title="新增" :visible.sync="theEditorShow2" :close-on-click-modal='false' width="620px">
        <el-form :model="form2" :rules="rules2" ref="ruleForm2" style="margin-top: 10px;">
          <el-form-item label="公司名称" :label-width="formLabelWidth" prop="realname">
            <el-input v-model="form2.realname" clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" autocomplete="off" placeholder="请输入公司名称" size="small" style="width: 425px;"></el-input>
          </el-form-item>
          <el-form-item label="用户名" :label-width="formLabelWidth" prop="username">
            <el-input v-model="form2.username" clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" autocomplete="off" placeholder="以字母开头6 - 16个字符包含数字、字母、下划线" size="small" style="width: 425px;"></el-input>
            <el-popover placement="top" width="200" trigger="hover" content="用户名不支持修改，请仔细考虑">
              <el-button slot="reference" icon="el-icon-warning-outline" type="text"></el-button>
            </el-popover>
          </el-form-item>
          <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
            <el-input v-model="form2.password" clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" autocomplete="off" placeholder="6 - 16个字符，区分大小写" show-password size="small" style="width: 425px;"></el-input>
          </el-form-item>
          <el-form-item label="备注名" :label-width="formLabelWidth">
            <el-input placeholder="请输入备注名" v-model="form2.memo" clearable size="small" style="width: 425px;">
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="form2.mobile" clearable style="width: 425px;" size="small" type="number">
            </el-input>
          </el-form-item>
          <el-form-item label="版本" :label-width="formLabelWidth" prop="newAddversion">
            <el-select v-model="form2.newAddversion" placeholder="请选择" clearable size="small" style="width: 425px;">
              <el-option :label="item.dictName" v-for="item in dict" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务期至" :label-width="formLabelWidth" prop="validtimebrm">
            <el-date-picker v-model="form2.validtimebrm" type="date" placeholder="选择日期" style="width: 425px;" format="yyyy-MM-dd" size="small">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="客户类型" :label-width="formLabelWidth" prop="members">
            <el-radio v-model="form2.members" label="0">一般客户</el-radio>
            <el-radio v-model="form2.members" label="1">重点客户</el-radio>
          </el-form-item>
          <el-form-item label="品牌数据限额" :label-width="formLabelWidth">
            <el-input placeholder="请输入" v-model="form2.datalimit" clearable style="width: 425px;" size="small" type="number">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm2('ruleForm2')" size="small">确 定</el-button>
          <el-button @click="theEditorShow2 = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 新增 -->
      <!-- 分配客服 -->
      <el-dialog title="分配客服" :visible.sync="customerShow" :close-on-click-modal='false' width="620px">
        <el-form :model="form3" :rules="rules3" ref="ruleForm3" style="margin-top: 10px;">
          <el-form-item label="服务客服" :label-width="formLabelWidth" prop="brmkefu">
            <el-select v-model="form3.brmkefu" multiple placeholder="请选择" style="width: 425px;" filterable size="small">
              <el-option
                v-for="item in brmList"
                :key="item.id"
                :label="item.realname"
                :value="item.id"
                :disabled="item.status != 1">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm3('ruleForm3')" size="small">确 定</el-button>
          <el-button @click="customerShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分配客服 -->
    </div>
    <!-- 停用 -->
    <el-dialog title="提示" :visible.sync="stopPhoneShow" width="360px" style="margin-top: 10%;" id="dialog" :close-on-click-modal='false'>
      <div style="display: flex;width: 100%;justify-content:center;">
         <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
         <div>
             <div style="font-size: 16px;">你确认要停用该用户账号吗？</div>
             <div style="font-size: 14px;">停用后
             <span style="color: #e90e24;font-size: 14px;">账号将无法使用</span>
          </div>
         </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="stopPhone()" size="small">确 定</el-button>
        <el-button @click="stopPhoneShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 停用 -->
    <!-- 批量停用 -->
    <el-dialog :visible.sync="stopPhoneShow2" width="360px" title="提示" id="dialog" style="margin-top: 10%;" :close-on-click-modal='false'>
      <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
         <div>
             <div style="font-size: 16px;">你确认要停用勾选的{{openNumber}}项用户账号吗？</div>
             <div style="font-size: 14px;">停用后
             <span style="color: #e90e24;font-size: 14px;">账号将无法使用</span>
          </div>
         </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="openPhone(2)" size="small">确 定</el-button>
        <el-button @click="stopPhoneShow2 = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 批量停用 -->
    <!-- 启用 -->
    <el-dialog :visible.sync="openPhoneShow" width="360px" title="提示" id="dialog" style="margin-top: 10%;" :close-on-click-modal='false'>
      <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
         <div>
             <div style="font-size: 16px;">你确认要启用该用户账号吗？</div>
             <div style="font-size: 14px;">启用后
             <span style="color: #e90e24;font-size: 14px;">账号将恢复正常使用</span>
          </div>
         </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="stopPhone()" size="small">确 定</el-button>
        <el-button @click="openPhoneShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 启用 -->
    <!-- 批量启用 -->
    <el-dialog :visible.sync="openPhoneShow2" width="360px" title="提示" id="dialog" style="margin-top: 10%;" :close-on-click-modal='false'>
      <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
         <div>
             <div style="font-size: 16px;">你确认要启用勾选的{{openNumber}}项用户账号吗？</div>
             <div style="font-size: 14px;">启用后
             <span style="color: #e90e24;font-size: 14px;">账号将恢复正常使用</span>
          </div>
         </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="openPhone(1)" size="small">确 定</el-button>
        <el-button @click="openPhoneShow2 = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 批量启用 -->
    <!-- 解绑手机 -->
    <el-dialog :visible.sync="unbundlingPhoneShow" width="360px" title="提示" id="dialog" style="margin-top: 10%;" :close-on-click-modal='false'>
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
           <div style="font-size: 16px;">你确认要解绑该用户绑定手机吗？</div>
           <div style="font-size: 14px;">解绑后
           <span style="color: #e90e24;font-size: 14px;">账号将取消当前绑定手机</span>
        </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="unbundlingPhone()" size="small">确 定</el-button>
        <el-button @click="unbundlingPhoneShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 解绑手机 -->
    <!-- 解绑微信 -->
    <el-dialog title="提示" :visible.sync="unbundlingWxShow" width="20%" style="margin-top: 10%;" id="dialog">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
        <div>
          <div style="font-size: 16px;">你确认要解绑微信绑定吗？</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBindWechatOrUnbind()" size="small">确 定</el-button>
        <el-button @click="unbundlingWxShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 解绑微信 -->
  </div>
</template>

<script>
  import aes from "../../libs/aes";
  import pagination from "../../components/dataTable/pagination";
  import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        newOpenid: '',
        newUserid: '',
        unbundlingWxShow: false,
        brmBmcid: '',
        customerShow: false,
        loading: false,
        input: '',
        dict: [],
        tableData: [],
        multipleSelection: [],
        linkTagData: [],
        companyname: '',
        companyMemoname: '',
        version: '',
        dataId: '',
        checkAll: 1,
        openNumber: 0,
        realname: '',
        username: '',
        status: '',
        batchUserIds: '',
        iprTheEditordata: [],
        useDisble: false,
        theEditorShow: false,
        theEditorShow2: false,
        stopPhoneShow: false,
        stopPhoneShow2: false,
        openPhoneShow: false,
        openPhoneShow2: false,
        unbundlingPhoneShow: false,
        totalNum: 100,
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        userIds: '',
        openStatus: '',
        mobiles: '',
        rules: {
          realname: [
           { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          username: [
           { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          password: [
           { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          newAddversion: [
           { required: true, message: '请选择版本', trigger: 'blur' },
          ],
          validtimebrm: [
           { required: true, message: '请选择服务期', trigger: 'blur' },
          ],
        },
        rules2: {
          realname: [
           { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          username: [
           { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          password: [
           { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          newAddversion: [
           { required: true, message: '请选择版本', trigger: 'blur' },
          ],
          validtimebrm: [
           { required: true, message: '请选择服务期', trigger: 'blur' },
          ],
        },
        rules3: {
          brmkefu: [
           { required: true, message: '请选择分配客服', trigger: 'blur' },
          ],
        },
        formLabelWidth: '100px',
        form: {
          realname: '',
          username: '',
          password: '******',
          roleIds: '',
          memo: '',
          bid: '',
          userid: '',
          mobile: '',
          validtimebrm: '',
          newAddversion: '',
          members: '0',
          datalimit: '',
        },
        form2: {
          realname: '',
          username: '',
          password: '',
          memo: '',
          mobile: '',
          roleIds: '',
          validtimebrm: '',
          newAddversion: '',
          members: '0',
          datalimit: '',
        },
        form3: {
          brmkefu: [],
        },
        brmList: [],
      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    mounted() {
      this.theQuery();
      this.GetList();
      this.getBRMList();
    },
    methods: {
      ...mapActions([
        'reqUnbindWx',
      ]),
      openWechat(openid,userid) {
        this.newOpenid = openid
        this.newUserid = userid
        this.unbundlingWxShow = true
      },
      // 解除绑定微信
      onBindWechatOrUnbind() {
        let data = {
          openid: this.newOpenid,
          usertype: 'c',
          domainname: window.location.host.substring(0, window.location.host.indexOf(".")),
          userid: this.newUserid
        }
        this.reqUnbindWx(data).then((res) => {
          if(res.status === '10000') {
            this.$message.success('解绑成功');
            this.unbundlingWxShow = false
            this.theQuery();
            this.GetList();
            this.getBRMList();
          }
        })
      },
      // 分配客服
      getBRMList() {
        let params={
          departmentId: '2',
          keyword: '',
          checkedids: '',
        }
        fetch({
          url: "hcm/departmentin/getDepartmentLeaderList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.brmList = data
          } else {
            this.$message.error(res.message);
          }
        })
      },
      // 分配客服
      fenKefu(brmBmcid,kefuid) {
        this.customerShow = true
        this.brmBmcid = brmBmcid
        this.form3.brmkefu = []
        console.log(kefuid)
        for(let i=0;i < kefuid.split(',').length;i++){
          this.form3.brmkefu.push(Number(kefuid.split(',')[i]))
        }
      },
      GetList() {
        let params={
          dictcode: 'version',
        }
        fetch({
          url: "hcm/sys/GetList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dict = data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })
      },
      theQuery(e) {
        this.loading = true
        if (e == 1) {
          this.pageNo = 1
          this.currentPage = 0
        }
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        if (this.companyname) {
          params.companyname = this.companyname;
        }
        if (this.companyMemoname) {
          params.companyMemoname = this.companyMemoname;
        }
        if (this.username) {
          params.username = this.username;
        }
        if (this.version) {
          params.version = this.version;
        }
        if (this.status) {
          params.status = this.status;
        }
        fetch({
          url: "hcm/userout/getUserPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.loading = false
            this.currentPage = 1
            this.tableData = data.content;
            this.totalNum = data.totalElements;
          } else {
            this.$message.error(res.message)
          }
        })
      },
      oneStep(e,f,h,k,g,companyname,companyMemoname,validtimebrm,versionid,members,mobile,datalimit) {
        console.log(members)
        console.log(datalimit)
        this.dataId = k;
        if (e == 1) {
          this.theEditorShow2 = true;
          this.form2.realname = '';
          this.form2.username = '';
          this.form2.password = '';
          this.form2.memo = '';
          this.form2.validtimebrm = '';
          this.form2.newAddversion = 1048;
          this.form2.members = '0';
          this.form2.mobile = '';
          this.form2.datalimit = '';
          
        } else {
          this.theEditorShow = true;
          this.form.realname = f;
          this.form.username = h;
          this.form.userid = k;
          this.form.bid = g;
          this.useDisble = true;
          this.form.realname = companyname
          this.form.memo = companyMemoname
          this.form.validtimebrm = this.$options.filters['formatDate'] (validtimebrm).substring(0,10);
          this.form.newAddversion = versionid;
          this.form.mobile = mobile;
          this.form.datalimit = datalimit;

          if (members == 1) {
            this.form.members = '1';
          } else {
            this.form.members = '0';
          }
        }
      },
      BrandSet(e,f,bmcid) {
        this.$router.push({
          path: '/BrandSet',query: { companyname: e ,id: f,bmcid: bmcid}
        })
      },

      disableAccounts() {
        this.stopPhoneShow = true
      },
      openAccounts() {
        this.openPhoneShow = true
      },
      unbundlingAccounts(e) {
        this.mobiles = e;
        this.unbundlingPhoneShow = true;
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
            this.openNumber = this.totalNum
            this.checkAll = 2
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.checkAll = 1
          this.openNumber = 0
        }
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.theQuery();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      stateSwitch(e,f) {
        this.userIds = f;
        this.openStatus = e;
        if (e == 1) {
          this.disableAccounts();
        } else {
          this.openAccounts();
        }
      },
      batchEnabled() {
        if (this.multipleSelection.length != 0) {
          this.openPhoneShow2 = true;
          if (this.checkAll == 2) {
            this.openNumber = this.totalNum;
          } else {
            this.openNumber = this.multipleSelection.length;
          }
        } else {
          this.$message({
            message: '请选择要启用的用户',
            type: 'warning'
          });
        }
      },
      batchOutage() {
        if (this.multipleSelection.length != 0) {
          this.stopPhoneShow2 = true;
          if (this.checkAll == 2) {
            this.openNumber = this.totalNum;
          } else {
            this.openNumber = this.multipleSelection.length;
          }
        } else {
          this.$message({
            message: '请选择要停用的用户',
            type: 'warning'
          });
        }
      },
      stopPhone() {
        let params={
          userIds: this.userIds,
          usertype: 'c'
        }
        if (this.openStatus == 1) {
          params.status = 2
        } else {
          params.status = 1
        }
        fetch({
          url: "hcm/user/StartOrStop",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.theQuery();
            this.stopPhoneShow = false;
            this.openPhoneShow = false;
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })
      },
      openPhone(e) {
        var arr = [];
        this.multipleSelection.forEach((val,index,val_arr)=>{
          arr.push(val.userid)
        });

        let params={
          usertype: 'u'
        }
        if (this.checkAll == 2) {
          params.userIds = 'checkAllBmc'
        } else {
          this.batchUserIds = arr.join();
          params.userIds = this.batchUserIds
        }
        if (e == 1) {
          params.status = 1
        } else {
          params.status = 2
        }
        fetch({
          url: "hcm/user/StartOrStop",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.theQuery();
            this.openPhoneShow2 = false;
            this.stopPhoneShow2 = false;
            this.checkAll = 1
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })

      },
      unbundlingPhone() {
        let params={
          mobiles: this.mobiles,
          usertype: 'c'
        }
        fetch({
          url: "hcm/user/UnbindPhone",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.theQuery();
            this.unbundlingPhoneShow = false;
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })

      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params={
              bid: this.form.bid,
              userId: this.form.userid,
              companyname: this.form.realname,
              username: this.form.username,
              password: aes.encrypt(this.form.password,'hcmabcdefghijklm'),
              companyMemoname: this.form.memo,
              system: 'BRM',
              version: this.form.newAddversion,
              validtimebrm: this.$options.filters['formatDate'] (this.form.validtimebrm).substring(0,10),
              members: Number(this.form.members),
            }
            if (this.form.mobile) {
              params.mobile = this.form.mobile
            }
            if (this.form.datalimit) {
              params.datalimit = this.form.datalimit
            }
            fetch({
              url: "hcm/userout/saveUserOut",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.theEditorShow = false
                this.theQuery();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                });
                this.theEditorShow = false
              }
            })
            .catch(err => {

            })
          } else {
            return false;
          }
        });
      },
      submitForm2(formName2) {
        console.log(this.form2.newAddversion)
        this.$refs[formName2].validate((valid) => {
          if (valid) {
            let params={
              companyname: this.form2.realname,
              username: this.form2.username,
              password: aes.encrypt(this.form2.password,'hcmabcdefghijklm'),
              companyMemoname: this.form2.memo,
              system: 'BRM',
              version: this.form2.newAddversion,
              validtimebrm: this.$options.filters['formatDate'] (this.form2.validtimebrm).substring(0,10),
              members: Number(this.form2.members),
            }
            if (this.form2.mobile) {
              params.mobile = this.form2.mobile
            }
            fetch({
              url: "hcm/userout/saveUserOut",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.theEditorShow2 = false
                this.theQuery();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                });
                this.theEditorShow2 = false
              }
            })
            .catch(err => {

            })
          } else {
            return false;
          }
        });
      },
      submitForm3(formName3) {
        console.log(this.form3.brmkefu)
        this.$refs[formName3].validate((valid) => {
          if (valid) {
            let params={
              bmcid: this.brmBmcid,
              kefuids: this.form3.brmkefu.join(','),
            }
            fetch({
              url: "hcm/cus/saveBrmByBmcid",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.customerShow = false
                this.theQuery();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                });
                this.customerShow = false
              }
            })
            .catch(err => {

            })
          } else {
            return false;
          }
        });
      }

    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page {
    padding: 20px;
    margin-top: 10px;
    background-color: white;
    height: 100%;
  }
  .headerSize {
    line-height: 28px;
    text-align: right;
  }
  .prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin-bottom: 8px;
  }
  .promptFont{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
  }
  .promptFont2{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

</style>
<style lang="scss">
#preventPollution {
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
}
</style>
